var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.70636H12C13.933 0.70636 15.5 2.27336 15.5 4.20636V12.2064C15.5 14.1394 13.933 15.7064 12 15.7064H4C2.067 15.7064 0.5 14.1394 0.5 12.2064V4.20636C0.5 2.27336 2.067 0.70636 4 0.70636Z",
    fill: "#FF8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.70636H12C13.933 0.70636 15.5 2.27336 15.5 4.20636V12.2064C15.5 14.1394 13.933 15.7064 12 15.7064H4C2.067 15.7064 0.5 14.1394 0.5 12.2064V4.20636C0.5 2.27336 2.067 0.70636 4 0.70636Z",
    stroke: "#FF8C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1826 10.2975L8.00037 6.11523L3.81812 10.2975",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "res/media/chevronUp.834dc270fff5334cc9881b600508a215.svg";
export { ForwardRef as ReactComponent };